import styled from 'styled-components';
import { Stack, Box } from '@koob/margaret';
import { fontStyles } from './theme';

export const FormErrorMessage = styled.span`
  display: block;
  padding-top: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ error, theme }) => (error ? theme.error : theme.warning)};
  font-size: 14px;
`;

export const FormGroup = styled.div`
  > * {
    margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  }
`;

export const FieldValidation = ({ status }) => (
  <FormLabel
    hasError={Boolean(status.isError)}
    hasSucceed={!Boolean(status.isError)}
  >
    {status?.message}
  </FormLabel>
);

export const FormLabel = styled(Box).attrs({ as: 'label', marginBottom: 0.5 })`
  ${fontStyles.bodySmall};

  text-align: left;
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  font-weight: 600;
  color: ${({ theme }) => theme.text};

  ${({ variant }) =>
    variant === 'bare' &&
    `
      margin-bottom: 0;
    `}
`;

export const FormField = styled(Stack).attrs({
  direction: 'column',
  size: 'full',
  alignX: 'stretch',
})`
  flex: 1;
  position: relative;
`;

export const InlineFormField = styled(Stack).attrs({
  direction: 'row',
  alignY: 'center',
})``;

export const ErrorMessage = styled.div`
  ${fontStyles.bodySmall};
  padding-top: ${({ theme }) => theme.spacing()};
  padding-bottom: ${({ theme }) => theme.spacing()};
  color: ${({ theme }) => theme.danger};
`;

export const HelperText = styled.div`
  ${fontStyles.bodySmall};
  color: ${({ theme }) => theme.textLight};
  padding-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const ErrorMessageWrapper = styled.div`
  ${fontStyles.bodySmall};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.danger};
`;
